import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import QRCode from 'react-qr-code';
import Styles, {
  BusinessCardMemberStyles,
} from './BusinessCardsTeamSection.styled';
import theme from '../../../styles/theme';
import { getHexValuesInString } from '../../../util/colors';
import GenerateQRCode from '../../Shared/Icons/GenerateQRCode';
import MailWireframe from '../../Shared/Icons/MailWireframe';
import Copy from '../../Shared/Icons/Copy';
import InView from '../../Shared/InView';
import tooltip from '../../Tooltip/Tooltip';
import sa from '../../../styles/Components/SimpleAnimation';
import SMS from '../../Shared/Icons/SMS';

export const BusinessCardMember = ({
  backgroundColor = theme.colors.white,
  email = '',
  phone = '',
  firstName = '',
  lastName = '',
  jobTitle,
  uid = '',
  photo = {
    src: '',
    alt: '',
  },
  onQRClick = () => {},
}) => {
  const location = useLocation();

  const copyToClipboard = () => {
    if (navigator) {
      const textContent = `Contact Info for ${firstName} ${lastName}: ${phone} ${email}`;
      navigator.clipboard.writeText(textContent);
    }
  };

  return (
    <BusinessCardMemberStyles
      className='business-card-member'
      backgroundColor={backgroundColor}
    >
      <div className='business-card-member__headshot'>
        <img src={photo.src} alt={photo.alt} />
      </div>
      <div className='business-card-member__name-and-qr'>
        <h3>
          {firstName} {lastName}
        </h3>
        <button className='icon-btn' onClick={() => onQRClick(uid)}>
          <GenerateQRCode color={theme.colors.claytonBlue} size={16} />
        </button>
      </div>
      <p className='business-card-member__title'>{jobTitle}</p>
      <a className='business-card-member__phone' href={`tel:${phone}`}>
        {phone}
      </a>
      <a className='business-card-member__email' href={`mailto:${email}`}>
        {email}
      </a>
      <div className='business-card-member__tools'>
        <a
          type='button'
          className='icon-btn icon-text-wrapper'
          target='_blank'
          href={`mailto:?subject=Contact Info: ${firstName} ${lastName}&body=${typeof window !== 'undefined' && window ? window?.location?.origin : 'https://vmf.com'}${location.pathname}#business_card_team_section`}
        >
          <MailWireframe
            color={theme.colors.claytonBlue}
            size={24}
            respect='height'
          />
          <span>Email</span>
        </a>
        <tooltip.button
          className='icon-btn'
          onClick={() => copyToClipboard()}
          tooltipText='Copied to Clipboard'
          showOnClick={true}
          showOnHover={false}
          xPosition='right'
          tooltipDuration={2000}
        >
          <div className='icon-text-wrapper'>
            <Copy color={theme.colors.claytonBlue} size={29} />
            <span>Copy</span>
          </div>
        </tooltip.button>
        <a
          className='icon-text-wrapper icon-btn sms-btn'
          href={`sms:?&body=${encodeURIComponent(`Contact Info for ${firstName} ${lastName} : ${phone} ${email}`)}`}
        >
          <SMS strokeClass='icon-btn-icon-stroke' size={22} />
          SMS
        </a>
      </div>
    </BusinessCardMemberStyles>
  );
};

const BusinessCardsTeamSection = ({
  businessCards = [],
  backgroundColor = theme.colors.grey6,
  header = '',
  headerTextColor = theme.colors.vmfBlue,
}) => {
  const [activeQRModal, setActiveQRModal] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (activeQRModal) {
      const top = document.documentElement.scrollTop;
      const left = document.documentElement.scrollLeft;
      if (window) window.onscroll = () => window.scrollTo(left, top);
    } else {
      if (window) window.onscroll = () => {};
    }
  }, [activeQRModal]);

  const openQRModal = uid => {
    setActiveQRModal(uid);
  };

  return (
    <InView>
      <Styles
        id='business_card_team_section'
        backgroundColor={backgroundColor}
        headerTextColor={headerTextColor}
      >
        {activeQRModal && (
          <>
            <sa.div
              className='qr-modal'
              onClick={() => setActiveQRModal(null)}
              delay={0}
              waitUntilInView={false}
            >
              <QRCode
                value={`${window ? window?.location?.origin : 'https://vmf.com'}${location.pathname}#business_card_team_section`}
                size={158}
                viewBox='0 0 158 158'
              />
            </sa.div>
            <sa.div
              className='qr-modal-backdrop'
              onClick={() => setActiveQRModal(null)}
              delay={0}
              waitUntilInView={false}
              shouldSlide={false}
            />
          </>
        )}
        <sa.h2 className='business-cards-team-section__header' delay={0.2}>
          {header}
        </sa.h2>
        <div className='business-cards-team-section'>
          {businessCards.map((v, i) => (
            <sa.div
              delay={0.2 * (i + 1)}
              className='business-cards-team-section__card'
            >
              <BusinessCardMember
                key={`bcard-${i}-${v.firstName}-${v.lastName}`}
                backgroundColor={getHexValuesInString(v.cardBackgroundColor)[0]}
                email={v.email}
                phone={v.phoneNumber}
                firstName={v.firstName}
                lastName={v.lastName}
                jobTitle={v.jobTitle}
                uid={v.uid}
                team={v.team}
                photo={{
                  src: v.headshotPhoto.fields.file.url,
                  alt: v.headshotPhoto.fields.description,
                }}
                onQRClick={openQRModal}
              />
            </sa.div>
          ))}
        </div>
      </Styles>
    </InView>
  );
};

export default BusinessCardsTeamSection;
